
import { Component,EventEmitter,ViewChild,ElementRef, Input, Inject } from '@angular/core';
import { APPCONFIG } from '../config';
import { DragulaService } from 'ng2-dragula';
import {Router, ActivatedRoute, Params} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { HttpService } from '../shared/services/http.service';
import { SessionHandler } from '../shared/services/session-handler.service';
import { dialogComponent } from '../dialog/dialog.component';
import { FileUploader,FileLikeObject} from 'ng2-file-upload';
import { HttpClient, HttpRequest, HttpResponse, HttpEvent, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OktaAuthStateService, OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import 'jquery';
import 'bootstrap';


@Component({
    selector: 'parametersComponent',
    template: require('./parameters.component.html'),
    styles: [require('./parameters.component.scss'),require('../custom_style.scss')],
    providers: [HttpService, SessionHandler, HttpClient]

})
export class ParametersComponent {
    finalParamList:any;
   

      choose = [
        "region",
        "country",
        "system" ,
       "consumerId",
       "transactionId",
        "applianceId" 
      ];
    
      selected = [
       
      ];
   
      accessToken: string = localStorage.getItem('accessToken');
     

      constructor(private dragulaService: DragulaService,private httpClient: HttpClient,private router: Router,  public httpService : HttpService,private activatedRoute: ActivatedRoute,  private oktaAuthStateService: OktaAuthStateService,
        @Inject(OKTA_AUTH) private oktaAuth: OktaAuth)
      {

        if(this.accessToken == null || this.accessToken == undefined || this.accessToken == "")
        {
          this.oktaAuthStateService.authState$.subscribe((authState) => {
            if (authState.isAuthenticated) {
              this.accessToken = authState.accessToken?.accessToken;
            } else {
              this.router.navigate(['/extra/login']);
            }
          });
        }
        this.dragulaService.createGroup("FOLDER_STRUCURE", {
          
        });
        this.dragulaService.drag("FOLDER_STRUCURE")
        .subscribe(res => {
            //console.log("drag"+res);
        }) ;
    this.dragulaService.drop("FOLDER_STRUCURE")
      .subscribe(res => {
        //console.log("drop"+res);
        })
      ;
        this.dragulaService.dropModel("FOLDER_STRUCURE").subscribe(res => {
          //console.log(res);
        });
      }


      drop(event: any): void 
      {
        this.finalParamList=JSON.stringify(event, null, 2);
      }


      public submitFolderStructure()
      {
        let token = localStorage.getItem('userEmail');
        const httpOptions = {
          headers : new HttpHeaders({
                'Content-Type': 'application/json',
                // 'googleEmailId': token,
                'Authorization': `Bearer ${this.accessToken}`,
                'region' : 'EMEA'
            }) };
           
      var data=JSON.parse(this.finalParamList);
      
     
      if(data[0] != "region" || data[1] != "country")
      {
      alert("region and country should come first");
      return;
      }
       this.httpService.postRequestWithHeader(data,"documentsServiceDocs/folderStructure",httpOptions).subscribe(
          res => {
           console.log(res);
           this.router.navigate(['/app/documents']);
          },
          err => {
            console.log(err);
          }
        )
      }
      
 
      ngOnDestroy()
      {
           this.dragulaService.destroy("FOLDER_STRUCURE") ;
     }





}